export const testimonials = [
  {
    name: 'Sarah J.',
    role: 'Registered Dental Hygienist · USA',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/753f0f7d-15aa-41af-b459-199fd993dc01.jpg',
    quote:
      'I used to keep three different notebooks for perio. The Master Map finally showed me how everything connects. Preparing case discussions feels so much more organized now.',
  },
  {
    name: 'Dr. Michael R.',
    role: 'General Dentist · Canada',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d3a0099a-ede8-4a7b-b3b2-52eddf73492b.jpg',
    quote:
      'The information-gap worksheet is my favorite part. It makes it obvious what I still need to evaluate before I start drawing conclusions about a case.',
  },
  {
    name: 'Emily T.',
    role: 'Dental Student · United Kingdom',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b43b697a-c4c8-4bcc-bf08-d629b3512e1a.jpg',
    quote:
      'Classification always felt like isolated definitions to me. The concept maps and comparison tables made my study sessions much easier to navigate.',
  },
  {
    name: 'Dr. Kevin L.',
    role: 'General Dentist · Australia',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a9c5de62-555b-44d1-8cac-565a620db5ea.jpg',
    quote:
      'I print the 15-Minute Protocol and keep it next to my notes. Having a repeatable sequence for my initial review saves me from rebuilding my own reference sheets.',
  },
];

export const recentBuyers = [
  { name: 'María González', country: 'Mexico', time: '2 minutes ago' },
  { name: 'Carlos Ramírez', country: 'Colombia', time: '4 minutes ago' },
  { name: 'Lucía Fernández', country: 'Argentina', time: 'just now' },
  { name: 'Javier Morales', country: 'Spain', time: '6 minutes ago' },
  { name: 'Valentina Rojas', country: 'Chile', time: '3 minutes ago' },
  { name: 'Diego Castillo', country: 'Peru', time: '1 minute ago' },
  { name: 'Camila Herrera', country: 'Ecuador', time: '8 minutes ago' },
  { name: 'Andrés Navarro', country: 'Dominican Republic', time: '5 minutes ago' },
  { name: 'Sofía Mendoza', country: 'Uruguay', time: '2 minutes ago' },
  { name: 'Mateo Vargas', country: 'Costa Rica', time: 'just now' },
  { name: 'Isabella Torres', country: 'Puerto Rico', time: '7 minutes ago' },
  { name: 'Alejandro Pérez', country: 'Guatemala', time: '9 minutes ago' },
];

export const faqs = [
  {
    q: 'How will I receive the material?',
    a: 'After completing your purchase, you’ll receive instructions for accessing Perio Blueprint™ and its included bonuses in digital format.',
  },
  {
    q: 'Is Perio Blueprint™ a course?',
    a: 'No. Perio Blueprint™ is a digital educational reference system containing six volumes, visual maps, worksheets, checklists, and educational practice cases. It is designed to help you organize and review periodontal concepts.',
  },
  {
    q: 'Is this product intended for periodontists only?',
    a: 'No. The material is designed for dental professionals and dental students who want a more structured way to study and organize periodontal knowledge. The appropriate use of the material depends on your training, professional role, and applicable regulations.',
  },
  {
    q: 'Does it replace clinical training or professional judgment?',
    a: 'No. Perio Blueprint™ is an educational resource. It does not replace formal training, current scientific evidence, a comprehensive patient examination, specialist consultation when indicated, or patient-specific clinical judgment.',
  },
  {
    q: 'Will it help me diagnose a patient in 15 minutes?',
    a: 'The 15-minute target refers to organizing an initial case review when the necessary information is available. It is not a promise that every periodontal case can be examined, diagnosed, or planned in that time.',
  },
  {
    q: 'Can I print the materials?',
    a: 'Yes. The materials are designed for digital consultation and printing, subject to the formats supplied with your purchase.',
  },
  {
    q: 'Is this a subscription?',
    a: 'No. The purchase is a one-time payment of $27 USD. There are no recurring monthly charges for the materials included in this offer.',
  },
  {
    q: 'Can I use the materials with real patient information?',
    a: 'The worksheets are designed to support professional organization and education. Always follow applicable privacy, confidentiality, and recordkeeping requirements. Do not upload identifiable patient information to AI tools or other services unless you have an appropriate legal basis and comply with applicable safeguards.',
  },
  {
    q: 'Are the clinical references reviewed?',
    a: 'The educational content and any clinical references should be verified against current, authoritative professional sources before publication and use. The materials are not a substitute for consulting the original sources or current clinical guidance.',
  },
  {
    q: 'What if I decide the product isn’t right for me?',
    a: 'Your purchase comes with a 7-day guarantee, subject to the published refund terms. Follow the instructions provided with your purchase to request a refund within the applicable period.',
  },
];
